import { handleActions } from 'redux-actions';
import { postData, putData } from '../utils/request';

const initialState = {
  error: null,
  first_name: '',
  last_name: '',
  mobile: '',
  date_of_birth: '',
  valid_g_license: false,
  existing_uber_partner: false,
  uberx_status: '',
  uber_uid: '',
  uber_token: '',
  uber_refresh_token: '',
  addresses: [
    {
      street_address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      moving_year: '',
      moving_month: '',
    },
  ],
  country_of_birth: '',
  city_of_birth: '',
  drivers_license_number: '',
  expiry_date: '',
  drivers_license_image: '',
  employment_eligibility_image: '',
  referral_source: '',
  referrer_code: '',
  other_referral_sources: '',
  step: 0,
};

const FORM_EDIT = 'FORM_EDIT';
const FORM_SUBMIT = 'FORM_SUBMIT';
const SUBMIT_FAILURE = 'SUBMIT_FAILURE';
const UPDATE_MOBILE = 'UPDATE_MOBILE';
const GET_UBERX = 'GET_UBERX';
const NEXT_STEP = 'NEXT_STEP';
const PREV_STEP = 'PREV_STEP';
const SET_STEP = 'SET_STEP';

/* ********************** ACTIONS ************************** */

const formEdit = (val, field) => ({
  type: [FORM_EDIT],
  val,
  field,
});

const formSubmit = () => ({
  type: [FORM_SUBMIT],
});

const submitFailure = error => ({
  type: [SUBMIT_FAILURE],
  error,
});

export const getUberx = uberx_status => ({
  type: [GET_UBERX],
  uberx_status,
});

export const tryFormEdit = ({ target }) => dispatch => {
  const val = target.value;
  const field = target.name;
  dispatch(formEdit(val, field));
};

export const tryFormEditSelect = (field, payload) => dispatch => {
  const val = payload;
  dispatch(formEdit(val, field));
};

export const tryFormEditDate = (field, date) => dispatch => {
  const val = date;
  dispatch(formEdit(val, field));
};

export const tryFormEditAddress = body => dispatch => {
  dispatch(formEdit(body, 'addresses'));
};

export const tryFormSubmit = (userBody, addressBody) => dispatch => {
  dispatch(formSubmit());
  return putData('users', userBody)
    .then(() => postData('addresses', addressBody))
    .catch(error => dispatch(submitFailure(error)));
};

export const updateMobile = mobile => ({
  type: [UPDATE_MOBILE],
  mobile,
});

export const nextStep = () => ({
  type: [NEXT_STEP],
});

export const prevStep = () => ({
  type: [PREV_STEP],
});

export const setStep = step => ({
  type: [SET_STEP],
  step,
});

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [FORM_EDIT]: (state, { val, field }) => ({
      ...state,
      [field]: val,
    }),

    [SUBMIT_FAILURE]: (state, { error }) => ({
      ...state,
      error,
    }),

    [FORM_SUBMIT]: state => ({
      ...state,
      error: null,
    }),

    [UPDATE_MOBILE]: (state, { mobile }) => ({
      ...state,
      mobile,
    }),
    [GET_UBERX]: (state, { uberx_status }) => ({
      ...state,
      uberx_status,
    }),
    [NEXT_STEP]: state => ({
      ...state,
      step: state.step + 1,
    }),
    [PREV_STEP]: state => ({
      ...state,
      step: state.step - 1,
    }),
    [SET_STEP]: (state, { step }) => ({
      ...state,
      step,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/apply.js